import { createRecord } from '@/entities/shared/record/create-record';
import type { Note } from '../schemas/note';
import { noteSchema } from '../schemas/note';

export async function createNote(data: Partial<Note>): Promise<string> {
  return createRecord('notes', noteSchema, data);
}
